var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteInstagramIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2 7.16406C8.332 7.16406 6 9.46226 6 12.2887V19.3844C6 22.2107 8.332 24.5089 11.2 24.5089H18.4C21.268 24.5089 23.6 22.2107 23.6 19.3844V12.2887C23.6 9.46226 21.268 7.16406 18.4 7.16406H11.2ZM19.6 10.3177C20.04 10.3177 20.4 10.6725 20.4 11.1061C20.4 11.5397 20.04 11.8945 19.6 11.8945C19.16 11.8945 18.8 11.5397 18.8 11.1061C18.8 10.6725 19.16 10.3177 19.6 10.3177ZM14.8 11.5003C17.228 11.5003 19.2 13.4437 19.2 15.8365C19.2 18.2294 17.228 20.1728 14.8 20.1728C12.372 20.1728 10.4 18.2294 10.4 15.8365C10.4 13.4437 12.372 11.5003 14.8 11.5003ZM14.8 12.2887C12.816 12.2887 11.2 13.8813 11.2 15.8365C11.2 17.7918 12.816 19.3844 14.8 19.3844C16.784 19.3844 18.4 17.7918 18.4 15.8365C18.4 13.8813 16.784 12.2887 14.8 12.2887Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteInstagramIcon);
export default __webpack_public_path__ + "static/media/whiteInstagramIcon.676124157d02f4a1ba8a0faec3888da3.svg";
export { ForwardRef as ReactComponent };